import { Outlet } from 'react-router';

import { InstanceNavigate } from '@/components/routing';
import { type FEATURE_FLAG_VALUE } from '@/constants/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

import { ROUTES } from './routes';

type Props = {
  flag: FEATURE_FLAG_VALUE;
};

const FeatureFlagRoute = ({ flag }: Props) => {
  const isEnabled = !!useFeatureFlag(flag);

  return isEnabled ? <Outlet /> : <InstanceNavigate to={ROUTES.dashboard.path} replace />;
};

export default FeatureFlagRoute;
